import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion.tsx'
import { PlayCircle, Video } from 'lucide-react'
import ClaimCertificate from '@/assets/help-documents/ClaimCertificate.mp4'
import AvApplication from '@/assets/help-documents/AvApplication.mp4'
import BrokerApplication from '@/assets/help-documents/BrokerApplication.mp4'
import InsuranceProviderApplication from '@/assets/help-documents/InsuranceProviderApplication.mp4'
import MotorCarrierApplication from '@/assets/help-documents/MotorCarrierApplication.mp4'
import LicensingAgency from '@/assets/help-documents/Licensing_Agent.mp4'

const SignUpHelpVideoLinks = () => {
  const VIDEOS = [
    { label: 'Claim Certificate', href: `${ClaimCertificate}` },
    { label: 'Broker Application', href: `${BrokerApplication}` },
    { label: 'Motor Carrier', href: `${MotorCarrierApplication}` },
    { label: 'AV Application', href: `${AvApplication}` },
    { label: 'Licensing Agency', href: `${LicensingAgency}` },
    {
      label: 'Insurance Provider Application',
      href: `${InsuranceProviderApplication}`,
    },
  ]

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full border-t border-slate-200 pt-4"
    >
      <AccordionItem value="item-1" className="border-b-0">
        <AccordionTrigger className="gap-2 py-0 text-sm font-semibold tracking-wide text-blue-800 uppercase hover:no-underline [&>svg]:text-blue-800">
          <span className="flex items-center gap-2">
            <Video className="h-4 w-4" />
            How to Sign Up Videos
          </span>
        </AccordionTrigger>
        <AccordionContent>
          <ul className="flex flex-col gap-1 pt-2">
            {VIDEOS.map((video) => (
              <li key={video.label}>
                <a
                  href={video.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-2.5 rounded-md px-2 py-2 text-sm text-slate-700 transition-colors hover:bg-blue-50 hover:text-blue-800"
                >
                  <PlayCircle className="h-4 w-4 shrink-0 text-blue-700 transition-transform group-hover:scale-110" />
                  <span>{video.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default SignUpHelpVideoLinks
